// XorShift128, same generator and seeding as utils/rng.rs in the poster code
// (sakerhetssm-generated-graphics), so seeds give the same glitches as the
// printed graphics.
export class XorShift128 {
    constructor (seed) {
        this.x = new Uint32Array(4)
        this.x[0] = seed >>> 0
        for (let i = 1; i < 4; i++) {
            this.x[i] = Math.imul(this.x[i - 1], 1812433253) ^ (this.x[i - 1] >>> 30)
        }
    }

    next () {
        const x = this.x
        const t = x[0] ^ (x[0] << 11)
        x[0] = x[1]
        x[1] = x[2]
        x[2] = x[3]
        x[3] = x[3] ^ (x[3] >>> 19) ^ t ^ (t >>> 8)
        return x[3]
    }

    // Uniform float in [0, 1).
    float () {
        return this.next() / 4294967296
    }

    // Uniform integer in [0, n).
    int (n) {
        return this.next() % n
    }

    range (min, max) {
        return min + this.float() * (max - min)
    }

    pick (items) {
        return items[this.int(items.length)]
    }
}

// FNV-1a, for turning names into seeds that are the same for everyone.
export function hashString (s) {
    let h = 2166136261
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i)
        h = Math.imul(h, 16777619)
    }
    return h >>> 0
}
